import { User } from "./api";

// Papel responde "quem é"; capacidade responde "o que pode" (campo `capabilities` do usuário).
export function can(user: User | null | undefined, capability: string) {
  return user?.capabilities?.includes(capability) ?? false;
}

export function isScopedSession(token: string | null | undefined, user: User | null | undefined) {
  if (user?.scopedTenantId) return true;
  if (!token) return false;
  try {
    const payload = token.split(".")[1].replaceAll("-", "+").replaceAll("_", "/");
    const padded = payload + "=".repeat((4 - (payload.length % 4)) % 4);
    const claims = JSON.parse(atob(padded)) as { scoped_tenant?: string };
    return Boolean(claims.scoped_tenant);
  } catch {
    return false;
  }
}

